// extracted by css-extract-rspack-plugin
export default {"nav":"nav-S2E_yR","leftSection":"leftSection-srcqOy","rightSection":"rightSection-eVyfCh","icon":"icon-Z3S4lt"};